(() => {
  const init = page => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const field = page.querySelector('[data-product-link]');
    if (!field) return;
    const normalize = value => {
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin || !/^\/products\/[a-z0-9-]+\/?$/.test(url.pathname)) return null;
        return url.origin + url.pathname;
      } catch { return null; }
    };
    const param = new URLSearchParams(location.search).get('product');
    if (param) { const value = normalize(param); if (value) field.value = value; }
    const validate = () => field.setCustomValidity(field.value && !normalize(field.value) ? field.dataset.invalidMessage : '');
    field.addEventListener('input', validate);
    field.addEventListener('change', validate);
    const submitterRole = page.querySelector('[data-submitter-role]');
    const guardianFields = page.querySelector('[data-guardian-fields]');
    const adultPermission = page.querySelector('[data-adult-permission]');
    const updateGuardian = () => {
      if (!submitterRole || !guardianFields || !adultPermission) return;
      const forChild = submitterRole.value === 'Parent or legal guardian';
      guardianFields.hidden = !forChild;
      guardianFields.disabled = !forChild;
      adultPermission.hidden = forChild;
      adultPermission.querySelector('input').disabled = forChild;
    };
    if (submitterRole) submitterRole.addEventListener('change', updateGuardian);
    updateGuardian();
    const menu = page.querySelector('[data-bee-menu]');
    const groups = [...page.querySelectorAll('[data-bee-group]')];
    const prompt = page.querySelector('[data-bee-prompt]');
    const update = () => {
      updateGuardian();
      groups.forEach(group => {
        const active = group.dataset.beeGroup === menu.value;
        group.hidden = !active;
        group.disabled = !active;
        group.querySelectorAll('input[type="radio"]').forEach(input => {
          input.disabled = !active;
          input.required = active;
          if (!active) input.checked = false;
        });
      });
      prompt.hidden = !!menu.value;
    };
    menu.addEventListener('change', update);
    update();
    window.addEventListener('pageshow', update);
    field.form.addEventListener('submit', event => {
      validate(); update();
      if (!field.form.checkValidity()) { event.preventDefault(); field.form.reportValidity(); }
    });
  };
  document.querySelectorAll('[data-fh-guest-form]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fh-guest-form]').forEach(init));
})();
